/* PD Vitrine « Nos robes du moment » : flèches de la colonne texte qui font défiler la piste de cartes
   (défilement natif aimanté) d'une carte à la fois ; flèches grisées aux extrémités. */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.pdVitrineReady) return;
    root.dataset.pdVitrineReady = 'true';
    const track = root.querySelector('[data-pd-vitrine-track]');
    const prev = root.querySelector('[data-pd-vitrine-prev]');
    const next = root.querySelector('[data-pd-vitrine-next]');
    if (!track || !prev || !next) return;

    const step = () => {
      const card = track.firstElementChild;
      if (!card) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    const update = () => {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const go = (dir) => track.scrollBy({ left: dir * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  const initAll = (scope) => scope.querySelectorAll('[data-pd-vitrine]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
